import { render, staticRenderFns } from "./ProductActivityCard.vue?vue&type=template&id=550ddce2&scoped=true&"
import script from "./ProductActivityCard.vue?vue&type=script&lang=js&"
export * from "./ProductActivityCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductActivityCard.vue?vue&type=style&index=0&id=550ddce2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550ddce2",
  null
  
)

export default component.exports